export const CookieInfo = {
    LOGIN_USER_INFO: "predamo-dms-user-info"
}

export function delCookie(name) {
    // 清除当前域名下的,例如：beta.credamo.cn
    document.cookie = name + '=0;path=/;expires=' + new Date(0).toUTCString()
    // 清除当前域名下的，例如 .beta.credamo.cn
    document.cookie = name + '=0;path=/;domain=' + document.domain + ';expires=' + new Date(0).toUTCString()
}


// WEBPACK FOOTER //
// ./src/lib/cookie.js